import { Button } from "../../../components/ui/button";
import { Heart } from "lucide-react";

export default function Donate() {
    return (
        <div className="flex justify-center pt-4 lg:pt-8">
            <Button 
                onClick={() => window.location.href = "https://lapa.africa/donate"}
                className='bg-green-600 hover:bg-green-900' 
                size="lg"
            >
                <Heart />
                Donate to our cause &rarr;
            </Button>
        </div>
    );
}
